export default class Cloak {
  constructor(store) {
    this.store = store;
    this.show = () => this.store.dispatch({ type: 'CLOAK_SHOW' });
    this.hide = () => this.store.dispatch({ type: 'CLOAK_HIDE' });
  }
}
